import { TechnologyCard } from "@types"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface SelectTechnologyProps {
  technologyCards?: TechnologyCard[]
  setTechnologyCards: Dispatch<SetStateAction<TechnologyCard[] | undefined>>
  setAddTechnology: Dispatch<SetStateAction<string>>
  setBookSlotPopup: Dispatch<SetStateAction<boolean>>
  addTechnology: string
}
export const SelectTechnology = ({
  technologyCards,
  setTechnologyCards,
  setAddTechnology,
  setBookSlotPopup,
  addTechnology,
}: SelectTechnologyProps) => {
  const toggleCheckbox = (index: number) => {
    const updatedData = technologyCards?.map((item, i) =>
      i === index ? { ...item, isChecked: !item.isChecked } : item
    )
    setTechnologyCards(updatedData)
  }
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <div className="mt-10 mb-5 pt-10 container mx-auto">
      <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
        Select Technology
      </h2>
      <div
        className={`py-4 lg:pl-10 px-3 lg:w-[90%] w-full rounded-xl mt-8 lg:mx-3 lg:mx-auto ${theme == "glassy" ? "bg-review-testimonial" : theme === "light" ? "bg-selection" : theme === "dark" ? "bg-review-testimonial" : "bg-white"}`}
      >
        <form className="flex gap-3 flex-wrap items-center mt-5">
          {technologyCards?.map((checkboxes, index) => (
            <div
              key={index}
              className="flex lg:w-[24%] my-1 gap-2 items-center"
            >
              <div
                onClick={() => toggleCheckbox(index)}
                className={`checkbox cursor-pointer border border-[#7B68EC] flex w-6 h-6 ${checkboxes?.isChecked ? "rounded-sm border-none" : ""}`}
              >
                {checkboxes?.isChecked && (
                  <div className="checked bg-[#7B68EC] w-full text-center text-white rounded-sm">
                    <div className="h-full w-full flex justify-center items-center">
                      <svg
                        className="flex justify-center items-center w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="13"
                        viewBox="0 0 17 13"
                        fill="none"
                      >
                        <path
                          d="M1 6.86667L6 12L16 1"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                )}
              </div>
              <p className="text-black lg:w-[80%]">{checkboxes?.title}</p>
            </div>
          ))}
        </form>
        <form>
          <div className="mt-8">
            <p className="text-black text-xs lg:text-sm">
              If you want another technology please write here.
            </p>
            <div className="lg:pr-5 flex pt-1">
              <input
                onChange={(e) => setAddTechnology(e.target.value)}
                value={addTechnology}
                className={`px-3 py-3 bg-form-input bg-input bg-glass text-black lg:w-[90%] w-[80%] rounded-s-xl outline-none ${theme == "glassy" ? "border border-[#7B68EC]" : theme === "light" ? "" : theme === "dark" ? "" : "border border-[#7B68EC] border-r-0"}`}
                type="text"
              />
              <div
                onClick={() => setBookSlotPopup(true)}
                className={`px-5 bg-[#7B68EC] lg:w-[10%] w-[20%] text-center cursor-pointer text-white py-3 rounded-e-xl ${addTechnology === "" ? "opacity-50 !cursor-not-allowed disabled" : ""}`}
              >
                Add
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
